import React from 'react'

// barrel file for loading states
import PropTypes from 'prop-types'
import AxisChartLoadingState from './AxisChartLoadingState.jsx'
import PieChartLoadingState from './PieChartLoadingState.jsx'
import GaugeLoadingState from './GaugeLoadingState'

const loadingStatesMap = {
  axis: AxisChartLoadingState,
  pie: PieChartLoadingState,
  gauge: GaugeLoadingState
}
const LoadingState = ({ type = 'pie', width, height = 300, ...loadingStateProps }) => {
  const Component = loadingStatesMap[type] ?? PieChartLoadingState
  return <Component {...loadingStateProps} width={width} height={height} />
}

LoadingState.propTypes = {
  type: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
}

export default LoadingState
